import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-submit-account',
  templateUrl: './submit-account.component.html',
  styleUrls: ['./submit-account.component.scss']
})
export class SubmitAccountComponent implements OnInit {
  @Input() recordId: any;
  @Input() submitAccountDetails: any;
  @Input() gatewayDetails: any;
  constructor() { }

  ngOnInit(): void {
    //do nothing
  }

}
